import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// Allow attaching a bearer token (for dev/test users / SSR fallback)
export const setAuthToken = (token) => {
    if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    else delete api.defaults.headers.common["Authorization"];
};

// Persist token if one was passed in URL (dev mode helper)
const stored = typeof window !== "undefined" && window.localStorage.getItem("yc_dev_token");
if (stored) setAuthToken(stored);
